import './App.css';
import { ListableWrapper } from './components/ListableWrapper';
import Footer from './Footer';


function App() {
  return (
    <div className="App">
      <ListableWrapper  />
      <Footer />
    </div>
  );
}

export default App;